import { Container } from '@uds/grid';
import Message from '@uds/message';
import TextButton from '@uds/text-button';
import Colorway, { Colorways } from '@uds/colorway';
import { BodyCopy } from '@uds/typography';
import { useAuth, getCustomer, getDelegate, useEndImpersonation, isCustomer } from '@ux/auth';
import './impersonationribbon.stylesheet_1qpvet0.css';
import { jsx, jsxs } from 'react/jsx-runtime';

const root = "rkcd0ei";
const inner = "injwnon";
const title = "ti3y6rv";
const classNames = {
  root,
  inner,
  title
};

const useImpersonationRibbon = () => {
  const user = useAuth();
  const customer = getCustomer(user);
  const delegate = getDelegate(user);
  const [onLogout, url] = useEndImpersonation();
  const onClick = e => {
    e.preventDefault();
    onLogout();
  };
  return {
    customer: customer === null || customer === void 0 ? void 0 : customer.shopperId,
    isCustomer: isCustomer(user),
    onClick,
    url,
    delegate: delegate == null ? null : [delegate.firstName, delegate.lastName].filter(Boolean).join(' ')
  };
};
function ImpersonationRibbon(_ref) {
  let {
    intlNamespace = 'ux.impersonation'
  } = _ref;
  const {
    customer,
    delegate,
    isCustomer,
    onClick,
    url
  } = useImpersonationRibbon();
  if (isCustomer || customer == null) {
    return null;
  }
  return /*#__PURE__*/jsx(Colorway, {
    colorway: Colorways.HIGHLIGHT,
    children: /*#__PURE__*/jsx("div", {
      className: classNames.root,
      children: /*#__PURE__*/jsx(Container, {
        children: /*#__PURE__*/jsxs("div", {
          className: classNames.inner,
          children: [/*#__PURE__*/jsx("div", {
            className: classNames.title,
            children: /*#__PURE__*/jsx(BodyCopy, {
              children: /*#__PURE__*/jsx(Message, {
                id: `${intlNamespace}.delegate`,
                values: {
                  delegate,
                  customer: /*#__PURE__*/jsx("strong", {
                    children: customer
                  })
                }
              })
            })
          }), /*#__PURE__*/jsx(TextButton, {
            href: url,
            onClick: onClick,
            children: /*#__PURE__*/jsx(Message, {
              id: `${intlNamespace}.logout`
            })
          })]
        })
      })
    })
  });
}

export { ImpersonationRibbon, ImpersonationRibbon as default };
